<template>
  <div class="fa-spin2">
    <img src="../assets/icons/spinner.svg" class="ico-17 fa-spin" /> 
  </div>
</template>
<script>
export default {
  name: "spinnerLoad",
  props: {
    color: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script> 
<style>
  .fa-spin {
    -webkit-animation: fa-spin 2s infinite linear;
    animation: fa-spin 2s infinite linear
  }
  .ico-17 {
    width: 17px !important;
    height: 17px !important;
 }
 
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes fa-spin {
  0% {
    -moz-transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>